// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3vn66","header":"MergedInvoice_header__2f386"};